import {FieldConfig} from '../../dynamic-field/field.config';
import {TextAutocompleteConfig} from '../../autocomplete/text-autocomplete.types';

export interface TextFieldConfig extends FieldConfig<string> {
    maxLength?: number;
    minLength?: number;
    placeholder?: string;
    hideClearButton?: boolean;
    showClearButtonIfReadonly?: boolean;
    /**
     * Optional autocomplete configuration that enables a dropdown of items
     * when the user types the configured triggerStart sequence.
     */
    autocompleteConfig?: TextAutocompleteConfig;
}
